import React, { useState } from 'react';
import { svgSprite } from '../../hybrid/wrappers';
import css from './accordionsingle.module.scss';
import classNames from 'classnames';

const AccordionSingle = ({ customStyles, title, children, arrowDirection = 'bottom', openDefault = false, icons }) => {
    const [animation, setAnimation] = useState(classNames(css.bodyAccordion, css.bodyAccordionHide));
    const [show, setShow] = useState(openDefault);

    const handlerAccordion = () => {
        setShow(!show);
        setTimeout(() => {
            show
                ? setAnimation(classNames(css.bodyAccordion, css.bodyAccordionHide, css.bodyAccordionHideAll))
                : setAnimation(classNames(css.bodyAccordion, css.bodyAccordionHide));
        }, 150);
    };
    return (
        <div className={customStyles?.wrapper}>
            <div className={customStyles?.titleAccordionWrapper || css.titleAccordionWrapper} onClick={handlerAccordion}>
                <div className={customStyles?.titleAccordion}>{title}</div>
                <div
                    className={
                        show
                            ? arrowDirection === 'top'
                                ? classNames(css.titleAccordionArrow, customStyles?.titleAccordionArrow)
                                : classNames(css.titleAccordionArrowHide, customStyles?.titleAccordionArrowHide)
                            : arrowDirection === 'top'
                            ? classNames(
                                  css?.titleAccordionArrow,
                                  css?.titleAccordionArrowHide,
                                  customStyles?.titleAccordionArrow
                              )
                            : classNames(css?.titleAccordionArrowRight, customStyles?.titleAccordionArrowRight)
                    }
                >
                    {svgSprite(show && icons?.opened ? icons?.opened : !show && icons?.closed ? icons?.closed : 'angle-right', {
                        className: css.svgAngel
                    })}
                </div>
            </div>
            {show && <div className={show ? css.bodyAccordion : animation}>{children}</div>}
        </div>
    );
};
export default AccordionSingle;
